import { createContext } from 'react';
import type { Capability, Membership, Profile, Workspace } from '../types/domain';

export interface AuthState {
  profile: Profile | null;
  memberships: Membership[];
  capabilities: Capability[];
  isPlatformAdmin: boolean;
  workspaces: Workspace[];
  selectedWorkspace: Workspace | null;
  accessToken: string | null;
  loading: boolean;
  selectWorkspace: (workspaceId: string) => void;
  updateWorkspaceAppearance: (
    organizationId: string,
    primaryColor: string,
    accentColor: string,
    usesAgencyLogo: boolean,
    usesAgencyName: boolean,
  ) => void;
  updateProfile: (fields: { fullName: string; phone: string | null; cnic?: string | null; dateOfBirth?: string | null; avatar?: File }) => Promise<string | null>;
  changePassword: (fields: { currentPassword: string; newPassword: string }) => Promise<string | null>;
  resendEmailVerification: () => Promise<string | null>;
  acceptRequiredConsents: (fields: { termsVersion: string; privacyVersion: string }) => Promise<string | null>;
  updateMarketingConsent: (accepted: boolean, version: string) => Promise<string | null>;
  registerBrandAmbassador: (fields: {
    accountType?: 'brand_ambassador' | 'organization';
    email: string;
    fullName: string;
    phone: string | null;
    city: string;
    password: string;
    termsAccepted: boolean;
    privacyAccepted: boolean;
    marketingConsent: boolean;
    termsVersion: string;
    privacyVersion: string;
    marketingVersion: string;
  }) => Promise<string | null>;
  signIn: (email: string, password: string) => Promise<string | null>;
  completeGoogleSignIn: (tokens: { access: string; refresh: string }) => void;
  signOut: () => void;
}

export const AuthContext = createContext<AuthState | null>(null);
